// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "tailwindcss/tailwind.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from "axios";
import funs from './uitls/funs';

Vue.use(ElementUI)

Vue.prototype.$api = axios
//Vue.prototype.$api.defaults.baseURL = 'http://jufanadmin.com'  //测试
Vue.prototype.$api.defaults.baseURL = 'http://jfkxadminapi.wxh5.net'   //正式

Vue.config.productionTip = false
Vue.prototype.$funs = funs

//添加全局前置路由守卫
router.beforeEach((to,from,next)=>{
  //判断token
  const token = localStorage.getItem('token')
  if (!token && to.name !== 'login') {
    next({name: 'login'})

  }
  next()

})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js